import { IPartialReducer } from "../../../../core/core-redux/reduxTypes";
import { FeatureInfoState } from "../../../redux/types";

export const cleanupFeatureInfoPartialReducer: IPartialReducer<FeatureInfoState> = (state, action) => {
    return {
        ...state,
        features: undefined,
    };
};
